import { render, staticRenderFns } from "./SessionRecords.vue?vue&type=template&id=8ab1c8ae"
import script from "./SessionRecords.vue?vue&type=script&lang=js"
export * from "./SessionRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports